module.exports = __webpack_public_path__ + "img/_icon_delete.f9468260.svg";